import { HttpService, VisibaApiPromise } from '@services/http.service';
import { HttpOptions } from '@visiba/http';
import { Singleton } from '@visiba/instantiation';
import { ApiBaseClient } from './_api_client_base';
import { IdentityApiModel } from './generated/models';

@Singleton()
export class IdentityApiService extends ApiBaseClient {
	constructor(private readonly httpService: HttpService) {
		super('identity');
	}

	public get(): VisibaApiPromise<IdentityApiModel | null> {
		return this.httpService.get(this.getBaseUri());
	}

	public signOut(): VisibaApiPromise<{ RedirectUrl: string | null }> {
		return this.httpService.post(this.getBaseUri() + '/signOut', null);
	}

	public deleteAccount(): VisibaApiPromise<unknown> {
		return this.httpService.delete(this.getBaseUri());
	}

	public canDeleteAccount(): VisibaApiPromise<unknown> {
		return this.httpService.get(this.getBaseUri() + '/CanDelete');
	}

	public isAlive(): VisibaApiPromise<boolean> {
		const options = new HttpOptions({
			requestConfig: {
				headers: {
					'X-TouchSessions': 'false',
				},
			},
		});

		return this.httpService.get(this.getBaseUri() + '/isAlive', options);
	}

	public isAliveOutsider(): VisibaApiPromise<boolean> {
		const options = new HttpOptions({
			requestConfig: {
				headers: {
					'X-TouchSessions': 'false',
				},
			},
		});

		return this.httpService.get(this.getBaseUri() + '/isAliveOutsider', options);
	}

	public getSignOutPath(returnUrl: string): string {
		const params = new URLSearchParams();
		params.append('returnUrl', returnUrl);

		// TODO: Should probably not hardcode "api" here... It won't hurt but it's a bit ugly.
		return `/api/${this.getBaseUri()}/signOutIdp?${params.toString()}`;
	}
}
